import { getFounderId, getToken } from "../../utilities/authStore";
import { executePromise } from "../../utilities/stores/chats/chatsStore.tools";

export function executeInviteCoFounder(email) {
  return executePromise(
    fetch(`${process.env.API_URL}/api/users/founders/invitation`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        founder: getFounderId(),
      }),
    })
  );
}

export function executeGetInvitationCofounder(token) {
  return executePromise(
    fetch(`${process.env.API_URL}/api/users/founders/invitation?token=${token}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      }
    })
  );  
}

export function executeCreateCoFounder(data) {
  return executePromise(
    fetch(`${process.env.API_URL}/api/users/founders/invitation/confirm`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({...data}),
    })
  );
}
